import { ComponentType, FC, memo } from "react";
import { SIDE } from "_constants";
import { StatusMessageBase } from "components/common/StatusMessageBase";
import { ReactComponent as PointIcon } from "../assets/tennis-point.svg";
import { ReactComponent as BreakPointIcon } from "../assets/tennis-break-point.svg";
import { ReactComponent as FailedServiceIcon } from "../assets/tennis-failed.svg";

type Props = {
  className?: string;
  team?: string | null;
  side: SIDE;
  Icon?: ComponentType<any>;
  title?: string;
  description?: string;
  normalizedCode: string;
  status: any;
  width: number;
  height: number;
};

const FORCE_NO_TEAM_CODES = new Set(["1114", "1115", "1118"]);
const ICONS_BY_CODE: Record<string, ComponentType<any>> = {
  "1114": PointIcon,
  "1115": BreakPointIcon,
  "1118": FailedServiceIcon,
};

export const StatusMessage: FC<Props> = memo((props) => {
  const { normalizedCode, team, title, Icon, ...rest } = props;
  const normalizedCodeStr = String(normalizedCode);
  const forceNoTeamLayout = FORCE_NO_TEAM_CODES.has(normalizedCodeStr);
  const resolvedTitle = forceNoTeamLayout ? team ?? title : title;
  const resolvedIcon = ICONS_BY_CODE[normalizedCodeStr] ?? Icon;

  return (
    <StatusMessageBase
      {...rest}
      normalizedCode={normalizedCodeStr}
      team={team}
      title={resolvedTitle}
      Icon={resolvedIcon}
      forceNoTeamLayout={forceNoTeamLayout}
      bottomCodes={[]}
      accentColor="#0c3f2e"
    />
  );
});
